const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <h2 className="section-title">JITBPについて</h2>
        <div className="about-zigzag">
          <div className="about-zigzag-row">
            <div className="about-zigzag-text">
              <p className="about-description">
              一般社団法人 日本ITビジネス・プロフェッショナル協会（JITBP）は、個人として活動するITを活用したビジネス・プロフェッショナル人材が、安心して力を発揮できる環境を整え、若手からベテランまで幅広く支援することを目的に設立されました。
              </p>
              <p className="about-description">
              私たちが目指すのは、ITの知識と経験を活かし、ビジネスのプロフェッショナルとしてスキルを研鑽し、顧客の成功を支援することで、日本社会全体のDX/AXを推進することです。
              </p>
            </div>
            <div className="about-zigzag-photo">
              <div className="about-photo-tilted">
                <img src="/images/team_photo_3mei.png" alt="チームメンバー" />
              </div>
            </div>
          </div>
          <div className="about-zigzag-row about-zigzag-row--reverse">
            <div className="about-zigzag-photo">
              <div className="about-photo-tilted about-photo-tilted--reverse">
                <img src="/images/team_photo_4mei.png" alt="チームメンバー" />
              </div>
            </div>
            <div className="about-zigzag-text">
              <p className="about-description">
              誠実に技術を磨き、信頼を築き、互いに学び合うことで、より良い日本社会を創り上げていく――そのための基盤を、この協会が提供してまいります。
              </p>
              <p className="about-description">
              さらに、この理念を広く社会に根付かせるために、賛助会員（法人・個人）を募り、賛同いただける企業・団体・個人の皆さまとともに、ITビジネス・プロフェッショナル人材が正しく評価され、活躍できる仕組みの確立を通じて、日本社会の持続的な成長に貢献してまいります。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About

